if (!window.Eurus.loadedScript.has('coupon-code.js')) {

  window.Eurus.loadedScript.add('coupon-code.js');



  const COTON_OFFERT_CODE = 'COTONOFFERT';
  const COTON_OFFERT_VARIANT_ID = 67581999513780;
  const COTON_OFFERT_MINIMUM = 7000; // 70,00 €
  const COTON_OFFERT_PROPERTY = '_cotonoffert_gift';
  const EG_GIFT_PROPERTY = '_Gifted';
  const COTON_OFFERT_STORAGE_KEY = 'cotonoffert_active';



  async function getCotonOffertCart() {

    const response = await fetch('/cart.js', {

      headers: {

        'Accept': 'application/json'

      }

    });



    if (!response.ok) {

      throw new Error('Impossible de récupérer le panier.');

    }



    return response.json();

  }



  function findCotonOffertGift(cart) {

    return cart.items.find(item =>

      Number(item.variant_id) === COTON_OFFERT_VARIANT_ID &&

      item.properties &&

      item.properties[COTON_OFFERT_PROPERTY] === 'true'

    );

  }



  function isCotonOffertGift(item) {
    return (
      Number(item.variant_id) === COTON_OFFERT_VARIANT_ID &&
      item.properties &&
      item.properties[COTON_OFFERT_PROPERTY] === 'true'
    );
  }

  function isEgGift(item) {
    return Boolean(item.properties && item.properties[EG_GIFT_PROPERTY]);
  }
  function isCotonOffertActive() {
    return sessionStorage.getItem(COTON_OFFERT_STORAGE_KEY) === 'true';
  }

  function setCotonOffertActive(active) {
    if (active) {
      sessionStorage.setItem(COTON_OFFERT_STORAGE_KEY, 'true');
    } else {
      sessionStorage.removeItem(COTON_OFFERT_STORAGE_KEY);
    }
  }
  function deactivateCotonOffert() {
    // Désactivation de la promotion
    setCotonOffertActive(false);

    // Suppression du code dans le store Alpine
    const couponStore = Alpine.store('xCouponCodeDetail');

    if (couponStore) {
      couponStore.appliedDiscountCodes =
        (couponStore.appliedDiscountCodes || []).filter(
          code => code.toUpperCase() !== COTON_OFFERT_CODE
        );
    }

    // Suppression du code dans le cookie Eurus,
    // sans toucher aux autres codes éventuels
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('eurus_discount_code='))
      ?.split('=')
      .slice(1)
      .join('') || '';

    const remainingCodes = decodeURIComponent(cookieValue)
      .split(',')
      .map(code => code.trim())
      .filter(code =>
        code && code.toUpperCase() !== COTON_OFFERT_CODE
      );

    document.cookie =
      `eurus_discount_code=${remainingCodes.join(',')}; path=/`;

    document.dispatchEvent(
      new CustomEvent('eurus:cart:discount-code:change')
    );
  }
  function hasCommercialLineDiscount(cart) {
    return cart.items.some(item => {
      // Les cadeaux EG et notre coton peuvent évidemment être remisés/gratuits.
      if (isEgGift(item) || isCotonOffertGift(item)) {
        return false;
      }

      const allocations = item.line_level_discount_allocations || [];
      const discounts = item.discounts || [];

      return (
        allocations.length > 0 ||
        discounts.length > 0 ||
        Number(item.final_line_price) < Number(item.original_line_price)
      );
    });
  }

  function hasOtherShopifyDiscountCode(cart) {
    return (cart.discount_codes || []).some(discount => {
      if (!discount || !discount.applicable) return false;

      const code = String(discount.code || '')
        .trim()
        .toUpperCase();

      return code && code !== COTON_OFFERT_CODE;
    });
  }

  function hasIncompatibleCotonOffertDiscount(cart) {
    return (
      hasCommercialLineDiscount(cart) ||
      hasOtherShopifyDiscountCode(cart)
    );
  }
  function getCotonOffertEligibleTotal(cart) {
    return cart.items.reduce((total, item) => {
      // Le coton cadeau et les cadeaux EG ne participent pas au seuil de 70 €.
      if (isCotonOffertGift(item) || isEgGift(item)) return total;
      return total + item.final_line_price;
    }, 0);
  }
  let cotonOffertCartWatcherTimer = null;
  let cotonOffertCartSyncRunning = false;

  async function updateCotonOffertGiftQuantity(gift, quantity) {
    const sections = Alpine.store('xCartHelper')
      .getSectionsToRender()
      .map((section) => section.id);

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: gift.key,
        quantity,
        sections
      })
    });

    if (!response.ok) {
      throw new Error(
        'Impossible de mettre à jour le cadeau COTONOFFERT.'
      );
    }

    const updatedCart = await response.json();

    if (updatedCart.sections) {
      Alpine.store('xCartHelper').reRenderSections(
        updatedCart.sections
      );
    }

    Alpine.store('xCartHelper').currentItemCount =
      updatedCart.item_count;

    return updatedCart;
  }

  function watchCotonOffertCartChanges() {
    const observer = new MutationObserver(() => {
      clearTimeout(cotonOffertCartWatcherTimer);

      cotonOffertCartWatcherTimer = setTimeout(async () => {
        if (cotonOffertCartSyncRunning) return;

        try {
          const cart = await getCotonOffertCart();
          const cotonGift = findCotonOffertGift(cart);

          // Aucun cadeau COTONOFFERT :
          // aucune intervention.
          // Aucun cadeau COTONOFFERT :
          // on nettoie un éventuel code encore actif.
          if (!cotonGift) {
            if (isCotonOffertActive()) {
              deactivateCotonOffert();
            }

            return;
          }

          const eligibleTotal =
            getCotonOffertEligibleTotal(cart);
          const cotonOffertActive =
            isCotonOffertActive();

          const incompatibleDiscount =
            hasIncompatibleCotonOffertDiscount(cart);
          console.log(
            '[COTONOFFERT] Montant éligible :',
            (eligibleTotal / 100).toFixed(2) + ' €'
          );
          // Le cadeau existe mais le code spécial
          // n'est plus actif.
          if (!cotonOffertActive) {
            console.log(
              '[COTONOFFERT] Code inactif → retrait du cadeau'
            );

            cotonOffertCartSyncRunning = true;

            await updateCotonOffertGiftQuantity(
              cotonGift,
              0
            );

            return;
          }

          // Une réduction commerciale est apparue
          // après l'activation de COTONOFFERT.
          if (incompatibleDiscount) {
            console.log(
              '[COTONOFFERT] Réduction incompatible → retrait du cadeau'
            );

            deactivateCotonOffert();

            cotonOffertCartSyncRunning = true;

            await updateCotonOffertGiftQuantity(
              cotonGift,
              0
            );

            return;
          }
          // Sous 70 € : retrait du cadeau.
          if (eligibleTotal < COTON_OFFERT_MINIMUM) {
            console.log(
              '[COTONOFFERT] Sous 70 € → retrait du cadeau'
            );

            cotonOffertCartSyncRunning = true;
            deactivateCotonOffert();
            await updateCotonOffertGiftQuantity(
              cotonGift,
              0
            );

            return;
          }

          // Le cadeau doit toujours rester à quantité 1.
          if (cotonGift.quantity !== 1) {
            console.log(
              '[COTONOFFERT] Quantité cadeau corrigée à 1'
            );

            cotonOffertCartSyncRunning = true;

            await updateCotonOffertGiftQuantity(
              cotonGift,
              1
            );
          }

        } catch (error) {
          console.error(
            '[COTONOFFERT] Surveillance panier :',
            error
          );
        } finally {
          cotonOffertCartSyncRunning = false;
        }
      }, 300);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  async function addCotonOffertGift() {
    const cart = await getCotonOffertCart();

    const eligibleTotal = getCotonOffertEligibleTotal(cart);

    // Minimum 70 €.
    if (eligibleTotal < COTON_OFFERT_MINIMUM) {
      console.log(
        '[COTONOFFERT] Panier insuffisant :',
        (eligibleTotal / 100).toFixed(2) + ' €'
      );

      return {
        success: false,
        reason: 'minimum'
      };
    }

    // Une vraie réduction commerciale est déjà présente.
    if (hasIncompatibleCotonOffertDiscount(cart)) {
      console.log(
        '[COTONOFFERT] Réduction incompatible détectée.'
      );

      return {
        success: false,
        reason: 'discount'
      };
    }

    const existingGift = findCotonOffertGift(cart);

    if (existingGift) {
      if (existingGift.quantity !== 1) {
        await updateCotonOffertGiftQuantity(
          existingGift,
          1
        );
      }

      return {
        success: true,
        reason: null
      };
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: COTON_OFFERT_VARIANT_ID,
            quantity: 1,
            properties: {
              [COTON_OFFERT_PROPERTY]: 'true'
            }
          }
        ]
      })
    });

    if (!response.ok) {
      throw new Error(
        'Impossible d’ajouter les Cotons au Curcuma.'
      );
    }

    console.log('[COTONOFFERT] Cadeau ajouté.');

    return {
      success: true,
      reason: null
    };
  }



  async function removeCotonOffertGift() {

    const cart = await getCotonOffertCart();

    const gift = findCotonOffertGift(cart);



    if (!gift) return false;



    const response = await fetch('/cart/change.js', {

      method: 'POST',

      headers: {

        'Content-Type': 'application/json',

        'Accept': 'application/json'

      },

      body: JSON.stringify({

        id: gift.key,

        quantity: 0

      })

    });



    if (!response.ok) {

      throw new Error('Impossible de retirer les Cotons au Curcuma.');

    }



    return true;

  }



  requestAnimationFrame(() => {

    document.addEventListener("alpine:init", () => {
      watchCotonOffertCartChanges();
      Alpine.data("xCouponCodeList", (sectionId) => ({

        loading: true,

        load() {

          this.loading = true;

          let url = `${window.location.pathname}?section_id=${sectionId}`;

          fetch(url, {

            method: 'GET'

          }).then(

            response => response.text()

          ).then(responseText => {

            const html = (new DOMParser()).parseFromString(responseText, 'text/html');

            const contentId = `x-promo-code-list-${sectionId}`;

            const newContent = html.getElementById(contentId);

            if (newContent && !document.getElementById(contentId)) {

              container.appendChild(newContent);

            }

            this.loading = false;

          })

        }

      }));



      Alpine.data("xCouponCode", (freeShippingCodes) => ({

        copySuccess: false,

        loading: false,

        disableCoupon: false,

        disableComing: false,

        discountCode: "",

        errorMessage: false,

        appliedDiscountCode: false,



        load(discountCode) {

          this.setAppliedButton(discountCode)

          document.addEventListener(`eurus:cart:discount-code:change`, (e) => {

            this.setAppliedButton(discountCode)

          })

        },



        copyCode() {

          if (this.copySuccess) return;



          const discountCode = this.$refs.code_value.textContent.trim();

          navigator.clipboard.writeText(discountCode).then(

            () => {

              this.copySuccess = true;

              const copyEvent = new Event('copy');

              document.dispatchEvent(copyEvent);



              setTimeout(() => {

                this.copySuccess = false;

              }, 5000);

            },

            () => {

              alert('Copy fail');

            }

          );

        },



        applyCouponCode(discountCode, isCart=false) {

          Alpine.store('xCouponCodeDetail').discountFaild = false;

          Alpine.store('xCouponCodeDetail').discountApplied = false;

          Alpine.store('xCouponCodeDetail').discountCorrect = false;

          Alpine.store('xCouponCodeDetail').getDiscountCode();



          let appliedDiscountCodes = JSON.parse(

            JSON.stringify(

              Alpine.store('xCouponCodeDetail').appliedDiscountCodes

            )

          );



          const appliedDiscount = document.querySelectorAll(

            ".discount-title:not(.hidden)"

          );



          let checkedDiscount = false;



          if (appliedDiscount.length > 0) {

            appliedDiscount.forEach((discount) => {

              if (

                discount.innerText.toLowerCase() ==

                discountCode.toLowerCase()

              ) {

                checkedDiscount = true;

              }

            });

          }



          if (freeShippingCodes) {

            if (freeShippingCodes.includes(this.discountCode)) {

              Alpine.store('xCouponCodeDetail').freeShippingApplied = true;



              setTimeout(() => {

                Alpine.store('xCouponCodeDetail').freeShippingApplied = false;

              }, 5000);



              return;

            }

          }



          if (checkedDiscount) {

            Alpine.store('xCouponCodeDetail').discountApplied = true;



            const field = document.querySelector("#x-cart-discount-field");

            if (field) field.value = '';



            this.discountCode = '';



            setTimeout(() => {

              Alpine.store('xCouponCodeDetail').discountApplied = false;

            }, 3000);



            return true;

          }



          if (discountCode) {

            let discountCodes =

              appliedDiscountCodes.length > 0

                ? [...new Set([...appliedDiscountCodes, discountCode])].join(",")

                : discountCode;



            this.loading = true;



            fetch('/cart/update.js', {

              method: 'POST',

              headers: {

                'Content-Type': 'application/json'

              },

              body: JSON.stringify({

                "discount": discountCodes,

                "sections": Alpine.store('xCartHelper')

                  .getSectionsToRender()

                  .map((section) => section.id)

              }),

            })

              .then(response => {

                return response.json();

              })

              .then((response) => {

                if (response.status != '422') {

                  Alpine.store('xCartHelper').reRenderSections(response.sections);



                  Alpine.store('xCouponCodeDetail').appliedDiscountCodes = [];



                  response.discount_codes.forEach(code => {

                    if (code.applicable) {

                      Alpine.store('xCouponCodeDetail')

                        .appliedDiscountCodes

                        .push(code.code);



                      if (code.code === discountCode) {

                        checkedDiscount = true;

                      }

                    }

                  });



                  document.cookie =

                    `eurus_discount_code=${Alpine.store('xCouponCodeDetail').appliedDiscountCodes}; path=/`;



                  if (checkedDiscount) {
                    Alpine.store('xCouponCodeDetail').discountCorrect = true;

                  } else {

                    Alpine.store('xCouponCodeDetail').discountFaild = true;



                    // Si Shopify refuse COTONOFFERT,

                    // on retire immédiatement le cadeau.

                    if (

                      discountCode &&

                      discountCode.toUpperCase() === COTON_OFFERT_CODE

                    ) {

                      removeCotonOffertGift()

                        .then((removed) => {

                          if (

                            removed &&

                            Alpine.store('xMiniCart')

                          ) {

                            Alpine.store('xMiniCart').reLoad();

                          }

                        })

                        .catch((error) => {

                          console.error(

                            '[COTONOFFERT] Suppression cadeau :',

                            error

                          );

                        });

                    }

                  }



                  Alpine.store('xCouponCodeDetail')

                    .appliedDiscountCodes

                    .push(discountCode);



                  const cartBubble =

                    document.querySelector('#cart-icon-bubble span');



                  if (cartBubble) {

                    Alpine.store('xCartHelper').currentItemCount =

                      parseInt(cartBubble.innerHTML);

                  }



                  document.dispatchEvent(

                    new CustomEvent(`eurus:cart:discount-code:change`)

                  );



                  if (isCart == false) {

                    this.setAppliedButton(discountCode);



                    if (

                      Alpine.store('xCartHelper').currentItemCount == 0

                    ) {

                      const elementError = this.$el

                        .closest('.promo-code-item')

                        ?.querySelector('.error-message');



                      this.errorMessage = true;



                      if (elementError) {

                        elementError.classList.remove(

                          'hidden',

                          'opacity-0'

                        );



                        elementError.classList.add(

                          'block',

                          'opacity-100'

                        );



                        setTimeout(function() {

                          elementError.classList.remove(

                            'block',

                            'opacity-100'

                          );



                          elementError.classList.add(

                            'hidden',

                            'opacity-0'

                          );



                          elementError.classList.add(

                            'hidden',

                            'opacity-0'

                          );

                        }, 3000);

                      }

                    } else {

                      this.errorMessage = false;

                      Alpine.store('xMiniCart').openCart();

                    }

                  }

                }

              })

              .finally(() => {

                this.loading = false;



                Alpine.store('xCouponCodeDetail').removedDiscountCode = '';



                setTimeout(() => {

                  Alpine.store('xCouponCodeDetail').discountFaild = false;

                }, 5000);



                setTimeout(() => {

                  Alpine.store('xCouponCodeDetail').discountCorrect = false;

                }, 3000);

              });

          }

        },



        handleScheduleCoupon(el) {

          let settings = xParseJSON(

            el.getAttribute('x-countdown-data')

          );



          let timeSettings =

            Alpine.store('xHelper').handleTime(settings);



          if (

            timeSettings.distance < 0 &&

            settings.set_end_date

          ) {

            this.disableCoupon = true;

          } else if (

            timeSettings.startTime > timeSettings.now

          ) {

            this.disableCoupon = true;

            this.disableComing = true;

          }

        },



        onChange() {

          this.discountCode = this.$el.value;

        },



        async applyDiscountToCart() {
          const discountCode =
            (this.discountCode || '').trim();

          // Tous les vrais codes Shopify :
          // comportement Eurus d'origine.
          if (
            discountCode.toUpperCase() !== COTON_OFFERT_CODE
          ) {
            this.applyCouponCode(discountCode, true);
            return;
          }

          this.loading = true;

          try {
            /*
            * COTONOFFERT n'est PAS envoyé à Shopify.
            *
            * Le produit cadeau vaut nativement 0 €.
            */

            const result = await addCotonOffertGift();

            if (!result.success) {
              setCotonOffertActive(false);

              Alpine.store('xCouponCodeDetail')
                .discountCorrect = false;

              Alpine.store('xCouponCodeDetail')
                .discountFaild = true;

              if (result.reason === 'minimum') {
                console.log(
                  '[COTONOFFERT] Minimum de 70 € non atteint.'
                );
              }

              if (result.reason === 'discount') {
                console.log(
                  '[COTONOFFERT] Une autre réduction est déjà active.'
                );
              }

              return;
            }

            /*
            * Le code spécial est maintenant actif.
            */
            setCotonOffertActive(true);

            Alpine.store('xCouponCodeDetail')
              .discountCorrect = true;

            Alpine.store('xCouponCodeDetail')
              .discountFaild = false;

            /*
            * On mémorise aussi le code dans le store Eurus
            * uniquement pour l'interface.
            */
            const codes =
              Alpine.store('xCouponCodeDetail')
                .appliedDiscountCodes;

            if (
              !codes.some(
                code =>
                  code.toUpperCase() ===
                  COTON_OFFERT_CODE
              )
            ) {
              codes.push(COTON_OFFERT_CODE);
            }
            document.cookie =
              `eurus_discount_code=${codes.join(',')}; path=/`;
            const field =
              document.querySelector(
                '#x-cart-discount-field'
              );

            if (field) {
              field.value = '';
            }

            this.discountCode = '';

            /*
            * Rafraîchissement du drawer :
            * le coton vient d'être ajouté via /cart/add.js.
            */
            if (Alpine.store('xMiniCart')) {
              Alpine.store('xMiniCart').reLoad();
            }

            document.dispatchEvent(
              new CustomEvent(
                'eurus:cart:discount-code:change'
              )
            );

            console.log(
              '[COTONOFFERT] Code spécial activé.'
            );

            setTimeout(() => {
              Alpine.store('xCouponCodeDetail')
                .discountCorrect = false;
            }, 3000);

          } catch (error) {
            console.error('[COTONOFFERT]', error);

            setCotonOffertActive(false);

            Alpine.store('xCouponCodeDetail')
              .discountFaild = true;

          } finally {
            this.loading = false;
          }
        },



        undoRemoveDiscount() {

          this.applyCouponCode(

            Alpine.store('xCouponCodeDetail').removedDiscountCode,

            true

          );

        },



        setAppliedButton(discountCode) {

          let appliedDiscountCodes = JSON.parse(

            JSON.stringify(

              Alpine.store('xCouponCodeDetail').appliedDiscountCodes

            )

          );



          if (

            discountCode &&

            appliedDiscountCodes.indexOf(discountCode) != -1

          ) {

            this.appliedDiscountCode = true;

          } else {

            this.appliedDiscountCode = false;

          }

        }

      }));



      Alpine.store('xCouponCodeDetail', {

        show: false,

        promoCodeDetail: {},

        sectionID: "",

        discountCodeApplied: "",

        appliedDiscountCodes: [],

        removedDiscountCode: '',

        cachedResults: [],

        loading: false,

        cartEmpty: true,

        discountFaild: false,

        discountApplied: false,

        freeShippingApplied: false,

        discountCorrect: false,



        handleCouponSelect(shopUrl) {

          var _this = this;



          const promoCodeDetail =

            JSON.parse(JSON.stringify(this.promoCodeDetail));



          document.addEventListener(

            'shopify:section:select',

            function(event) {

              if (

                event.target.classList.contains('section-promo-code') == false

              ) {

                if (window.Alpine) {

                  _this.close();

                } else {

                  document.addEventListener(

                    'alpine:initialized',

                    () => {

                      _this.close();

                    }

                  );

                }

              }

            }

          );



          if (

            promoCodeDetail &&

            promoCodeDetail.blockID &&

            promoCodeDetail.sectionID

          ) {

            this.promoCodeDetail = xParseJSON(

              document

                .getElementById(

                  'x-data-promocode-' + promoCodeDetail.blockID

                )

                .getAttribute('x-data-promocode')

            );



            let contentContainer =

              document.getElementById(

                'PromoCodeContent-' +

                this.promoCodeDetail.sectionID

              );



            if (

              this.cachedResults[

                this.promoCodeDetail.blockID

              ]

            ) {

              contentContainer.innerHTML =

                this.cachedResults[

                  this.promoCodeDetail.blockID

                ];



              return true;

            }



            if (this.promoCodeDetail.page != '') {

              let url =

                `${shopUrl}/pages/${this.promoCodeDetail.page}`;



              fetch(url, {

                method: 'GET'

              })

                .then(response => response.text())

                .then(responseText => {

                  const html =

                    (new DOMParser()).parseFromString(

                      responseText,

                      'text/html'

                    );



                  contentContainer.innerHTML =

                    html.querySelector(

                      ".page__container .page__body"

                    ).innerHTML;

                });



            } else if (

              this.promoCodeDetail.details != ''

            ) {

              contentContainer.innerHTML =

                this.promoCodeDetail.details;



              contentContainer.innerHTML =

                contentContainer.textContent;

            }

          }

        },



        load(el, blockID, shopUrl) {

          this.promoCodeDetail = xParseJSON(

            el.closest(

              '#x-data-promocode-' + blockID

            ).getAttribute('x-data-promocode')

          );



          let contentContainer =

            document.getElementById(

              'PromoCodeContent-' +

              this.promoCodeDetail.sectionID

            );



          this.sectionID =

            this.promoCodeDetail.sectionID;



          if (this.cachedResults[blockID]) {

            contentContainer.innerHTML =

              this.cachedResults[blockID];



            return true;

          }



          if (this.promoCodeDetail.page != '') {

            this.loading = true;



            let url =

              `${shopUrl}/pages/${this.promoCodeDetail.page}`;



            fetch(url, {

              method: 'GET'

            })

              .then(response => response.text())

              .then(responseText => {

                const html =

                  (new DOMParser()).parseFromString(

                    responseText,

                    'text/html'

                  );



                const content =

                  html.querySelector(

                    ".page__container .page__body"

                  ).innerHTML;



                contentContainer.innerHTML = content;

                this.cachedResults[blockID] = content;

              })

              .finally(() => {

                this.loading = false;

              });



          } else if (

            this.promoCodeDetail.details != ''

          ) {

            contentContainer.innerHTML =

              this.promoCodeDetail.details;



            contentContainer.innerHTML =

              contentContainer.textContent;

          }

        },



        showPromoCodeDetail() {

          this.show = true;

          Alpine.store('xPopup').open = true;

        },



        close() {

          this.show = false;

          Alpine.store('xPopup').close();

        },



        async removeDiscountCode(el, isCart = false) {
          Alpine.store('xCouponCodeDetail').discountFaild = false;
          Alpine.store('xCouponCodeDetail').discountApplied = false;
          Alpine.store('xCouponCodeDetail').discountCorrect = false;

          const discountCode = el
            .closest('li.x-discount')
            .querySelector('.discount-title:not(.hidden)')
            .textContent
            .trim();

          /*
          * ==========================================
          * COTONOFFERT
          * ==========================================
          *
          * Ce n'est PAS un code Shopify.
          */
          if (
            discountCode.toUpperCase() ===
            COTON_OFFERT_CODE
          ) {
            this.loading = true;

            try {
              setCotonOffertActive(false);

              await removeCotonOffertGift();

              this.appliedDiscountCodes =
                this.appliedDiscountCodes.filter(
                  code =>
                    code.toUpperCase() !==
                    COTON_OFFERT_CODE
                );

              document.cookie =
                `eurus_discount_code=${this.appliedDiscountCodes.join(',')}; path=/`;

              if (Alpine.store('xMiniCart')) {
                Alpine.store('xMiniCart').reLoad();
              }

              document.dispatchEvent(
                new CustomEvent(
                  'eurus:cart:discount-code:change'
                )
              );

            } catch (error) {
              console.error(
                '[COTONOFFERT] Suppression :',
                error
              );
            } finally {
              this.loading = false;
            }

            return;
          }


          /*
          * ==========================================
          * VRAIS CODES SHOPIFY
          * ==========================================
          *
          * On repart directement du panier Shopify.
          * On ne se fie PAS au cookie Eurus.
          */
          this.loading = true;

          try {
            const cartResponse = await fetch('/cart.js', {
              headers: {
                'Accept': 'application/json'
              }
            });

            if (!cartResponse.ok) {
              throw new Error(
                'Impossible de récupérer le panier.'
              );
            }

            const cart = await cartResponse.json();

            /*
            * Liste uniquement les vrais codes Shopify
            * actuellement applicables.
            */
            const shopifyCodes = (cart.discount_codes || [])
              .filter(code => code.applicable)
              .map(code => code.code);

            /*
            * On retire celui sur lequel le client
            * vient de cliquer.
            */
            const remainingCodes = shopifyCodes.filter(
              code =>
                code.toLowerCase() !==
                discountCode.toLowerCase()
            );

            const response = await fetch('/cart/update.js', {
              method: 'POST',

              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },

              body: JSON.stringify({
                discount: remainingCodes.join(','),

                sections:
                  Alpine.store('xCartHelper')
                    .getSectionsToRender()
                    .map(section => section.id)
              })
            });

            if (!response.ok) {
              throw new Error(
                'Impossible de supprimer le code promo.'
              );
            }

            const updatedCart = await response.json();

            /*
            * Eurus : on réaffiche les sections
            * retournées par Shopify.
            */
            if (updatedCart.sections) {
              Alpine.store('xCartHelper')
                .reRenderSections(
                  updatedCart.sections
                );
            }


            /*
            * On reconstruit le store avec uniquement
            * les vrais codes encore actifs.
            */
            this.appliedDiscountCodes = [];

            (updatedCart.discount_codes || [])
              .forEach(code => {
                if (code.applicable) {
                  this.appliedDiscountCodes.push(
                    code.code
                  );
                }
              });


            /*
            * Si COTONOFFERT est réellement actif,
            * on le remet uniquement pour l'interface.
            */
            if (
              isCotonOffertActive() &&
              !this.appliedDiscountCodes.some(
                code =>
                  code.toUpperCase() ===
                  COTON_OFFERT_CODE
              )
            ) {
              this.appliedDiscountCodes.push(
                COTON_OFFERT_CODE
              );
            }


            document.cookie =
              `eurus_discount_code=${this.appliedDiscountCodes.join(',')}; path=/`;


            const cartBubble =
              document.querySelector(
                '#cart-icon-bubble span'
              );

            if (cartBubble) {
              Alpine.store('xCartHelper')
                .currentItemCount =
                  parseInt(cartBubble.innerHTML);
            }


            document.dispatchEvent(
              new CustomEvent(
                'eurus:cart:discount-code:change'
              )
            );


            if (!isCart) {
              this.setAppliedButton(
                discountCode
              );

              if (
                Alpine.store('xCartHelper')
                  .currentItemCount > 0
              ) {
                Alpine.store('xMiniCart')
                  .openCart();
              }
            }

          } catch (error) {

            console.error(
              '[DISCOUNT] Suppression :',
              error
            );

          } finally {

            this.loading = false;

            this.removedDiscountCode =
              discountCode;

            setTimeout(() => {
              Alpine.store('xCouponCodeDetail')
                .discountFaild = false;
            }, 5000);

            setTimeout(() => {
              Alpine.store('xCouponCodeDetail')
                .discountCorrect = false;
            }, 3000);
          }
        },



        clearRemovedDiscount() {

          this.removedDiscountCode = '';

        },



        getDiscountCode() {

          let cookieValue =

            document.cookie.match(

              '(^|;)\\s*' +

              'eurus_discount_code' +

              '\\s*=\\s*([^;]+)'

            );



          let appliedDiscountCodes =

            cookieValue

              ? cookieValue.pop()

              : '';



          if (appliedDiscountCodes) {
            this.appliedDiscountCodes =
              appliedDiscountCodes
                .split(",")
                .filter(Boolean);
          } else {
            this.appliedDiscountCodes = [];
          }

          /*
          * COTONOFFERT n'est pas un vrai code Shopify.
          * On le restaure depuis notre état local.
          */
          if (
            isCotonOffertActive() &&
            !this.appliedDiscountCodes.some(
              code =>
                code.toUpperCase() ===
                COTON_OFFERT_CODE
            )
          ) {
            this.appliedDiscountCodes.push(
              COTON_OFFERT_CODE
            );
          }

        }

      });
      Alpine.store('xCouponCodeDetail').getDiscountCode();
    });

  });

}